import { useMutation, useQueryClient } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import type { AxiosError } from 'axios';
import { message } from 'antd';

import Api from '@/services/api';
import type { BaseContext, Response } from '@/types';

export type UpdateResultScore = {
	result: number;
	sum_score: number;
	worst_score: number;
	average_score: number;
};

export type UpdateResultScoreDTO = BaseContext & {
	custom_report_result_id?: string;
};

async function updateResultScores(body: UpdateResultScoreDTO): Promise<UpdateResultScore> {
	const url = '/custom-report/result/score';
	const { data } = await Api.put<UpdateResultScore>(url, body);
	return data;
}

export const useUpdateCustomReportResultScores = () => {
	const queryClient = useQueryClient();
	return useMutation<UpdateResultScore, AxiosError<Response>, UpdateResultScoreDTO>(
		(body) => updateResultScores(body),
		{
			onError: (err) => {
				message.error(I18n.get(err?.response?.data?.message ?? err?.message));
			},
			onSuccess: () => {
				queryClient.invalidateQueries(['jds_d86_report']);
				queryClient.invalidateQueries(['jds_d86_result']);
			}
		}
	);
};
